<template>
  <div class="registration">
    <advertising-figure :bannerSrc="bannerSrc" />
    <div class="inner-page-nav">
      <inner-page-nav />
    </div>
    <div class="inner-page-content">
      <public-title title="申请退费">
        <span class="sub">Refund Information</span>
      </public-title>
      <div class="refund-form">
        <refundForm
          :form="localItem"
          :rules="rules"
          :list="list"
          :btns="btns"
          :labelPosition="labelPosition"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import AdvertisingFigure from "@components/advertising"
  import InnerPageNav from "@components/tool-nav"
  import publicTitle from "@components/title"
  import refundForm from "@/components/form"
  import CurrentUserMixin from "@/mixin/CurrentUser"
  import { UserOrderRecord } from "@/store/entity/pay"

  export default {
    name: "refundPage",
    mixins: [CurrentUserMixin],
    components: {
      AdvertisingFigure,
      InnerPageNav,
      publicTitle,
      refundForm,
    },
    data() {
      return {
        labelPosition: "top",
        bannerSrc: require("@assets/img/registration-banner.png"),
        reason: "",
        rules: {
          reason: [{ required: true, message: "请输入申请退款理由" }],
        },
      }
    },

    mounted() {
      const reason = this.currentSignup.paid_order.refund_reason
      if (reason && reason.length > 0) {
        this.reason = reason
      }
    },
    watch: {
      "currentSignup.paid_order.refund_reason": function (reason) {
        // 如果填写过，写入填写的值
        if (reason && reason.length > 0) {
          this.reason = reason
        }
      },
    },

    computed: {
      localItem() {
        return {
          name: this.currentSignup.name,
          phone: this.currentSignup.phone,
          attendid_name: this.currentSignup.attendid.name,
          paid_prize: this.currentSignup.paid_order.paid_prize,
          paid_status: this.currentSignup.paid_status,
          reason: this.reason,
        }
      },
      list() {
        return [
          {
            label: "姓名",
            prop: "name",
            render: "ElInput",
            attrs: {
              disabled: true,
            },
            position: {
              span: 24,
            },
          },
          {
            label: "手机号",
            prop: "phone",
            render: "ElInput",
            attrs: {
              disabled: true,
            },
            position: {
              span: 24,
            },
          },
          {
            label: "参会身份",
            prop: "attendid_name",
            render: "ElInput",
            attrs: {
              disabled: true,
            },
            position: {
              span: 24,
            },
          },
          {
            label: "缴费金额",
            prop: "paid_prize",
            render: "ElInput",
            attrs: {
              disabled: true,
            },
            position: {
              span: 24,
            },
          },
          {
            label: "缴费状态",
            prop: "paid_status",
            render: "ElInput",
            attrs: {
              disabled: true,
            },
            position: {
              span: 24,
            },
          },
          {
            label: "退费原因",
            prop: "reason",
            render: "ElInput",
            attrs: {
              type: "textarea",
            },
            position: {
              span: 24,
            },
            listeners: {
              input: (value)=> this.reason=value,
            },
          },
        ]
      },

      btns() {
        return [
          {
            label: "提交申请",
            attrs: { type: "primary", class: "submitBtn" },
            listeners: {
              click: this.handleSubmit,
            },
          },
        ]
      },
    },

    methods: {
      async handleSubmit() {
        if (
          this.currentSignup.paid_status == "已缴费" ||
          this.currentSignup.paid_status == "申请退费"
        ) {
          const data = {
            trade_no: this.currentSignup.paid_order.trade_no,
            refund_reason: this.reason,
          }
          await UserOrderRecord.createRefund(data)
          // 然后刷新signup状态
          const phone = this.currentSignup.phone
          const conference_id = this.currentSignup.conference_id
          // 因为getSignupInfo是有缓存的，先重置状态再获取
          await this.$store.dispatch("user/resetFetchSignupInfo")
          this.$message("申请退款成功，请等待审核通知短信。")
          this.$router.replace({ name: "RegistrationDetail" })
        } else {
          this.$message("未支付完成或者已处理退款")
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import "@assets/scss/innerpagenav.scss";

  ::v-deep .el-col {
    padding: 0 15px;

    .submitBtn {
      display: block;
      width: 120px;
      margin: 60px auto 0;
    }
  }

  ::v-deep .el-select {
    width: 100%;
  }

  .inner-page-nav {
    position: relative;
    width: 1200px;
    height: 60px;
    padding: 0 15px;
    margin: 0 auto;
  }

  .inner-page-content {
    margin: 60px 0;
  }

  .refund-form {
    width: 1200px;
    padding: 0 15px;
    margin: 60px auto 0;
  }

  ::v-deep .el-dialog {
    background-color: #fe0000;
    border-radius: 5px;
    .el-dialog__title,
    .el-dialog__close {
      color: #fff;
    }
  }
</style>
